"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullInsuranceType = 'KS';
exports.partInsuranceType = 'RRS';
exports.travelInsuranceType = 'AK';
exports.familyCombination = 'FAM';
exports.coupleCombination = 'CPL';
exports.standardCombination = 'STD';
//# sourceMappingURL=types.js.map